<template>
  <v-card>
    <v-card-title class="text-centered" v-if="projetSelected">
      {{ projetSelected.ll_programme }}
    </v-card-title>
    <v-card-text>
      <template>
        <v-data-table
          hide-default-header
          hide-default-footer
          class="elevation-0"
          :headers="headers"
          :items="user.projets"
        >
          <template v-slot:item.actions="{ item }">
            <div>
              <div v-if="item.id_programme === projetSelected.id_programme">
                <div v-if="arrays == 8">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        block
                        no-caps
                        v-bind="attrs"
                        v-on="on"
                        @click="continuer(item)"
                        class="mx-2 text-lowercase"
                        rounded
                        dark
                        color="blue"
                      >
                        continuer : {{ item.ll_programme }}
                        <v-icon dark>
                          mdi-motion-play-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Continuer avec ce projet</span>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        block
                        rounded
                        v-bind="attrs"
                        v-on="on"
                        class="mx-2 text-lowercase"
                        dark
                        color="blue"
                        @click="loadAll()"
                        :loading="loading"
                      >
                        charger {{ item.ll_programme }}
                        <v-icon right dark>
                          mdi-motion-play-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Charger les données ci dessous d'abord </span>
                  </v-tooltip>
                </div>
              </div>
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      rounded
                      v-bind="attrs"
                      v-on="on"
                      @click="changeProjet(item)"
                      class="mx-2 text-lowercase"
                      dark
                      color="red"
                    >
                      charger {{ item.ll_programme }}
                      <v-icon right dark>
                        mdi-logout
                      </v-icon>
                    </v-btn>
                  </template>
                  <span
                    >sortir et Changer le projet actif en
                    {{ item.ll_programme }}</span
                  >
                </v-tooltip>
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
    <v-card-text v-if="projetSelected">
      <!--   <v-list v-if="online">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="paramsLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Paramètres </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadParams()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="groupesLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Groupes :
              <span v-if="groupesDeSuperviseur.length > 0">{{
                groupesDeSuperviseur.length
              }}</span></v-list-item-title
            >

            <v-list-item-title
              >Hors groupe :
              <span v-if="horsGroupe.length > 0">{{
                horsGroupe.length
              }}</span></v-list-item-title
            >
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadGroupes()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="membresLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Membres:
              <span v-if="MembresDuSuperviseur.length > 0">{{
                MembresDuSuperviseur.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="GetMembresDuSuperviseur(user.uid)">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="menagesLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Ménages:
              <span v-if="MenagesDuSuperviseur.length > 0">{{
                MenagesDuSuperviseur.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadMenages()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="campagnesLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Campagnes:
              <span v-if="ParcoursEffectif.length > 0">{{
                ParcoursEffectif.length
              }}</span>
            </v-list-item-title>
            <v-list-item-title
              >Etapes:
              <span v-if="etapeEffectiveDeAnimateur.length > 0">{{
                etapeEffectiveDeAnimateur.length
              }}</span>
            </v-list-item-title>

            <v-list-item-title
              >Fiches:
              <span v-if="ficheDeAnimateur.length > 0">{{
                ficheDeAnimateur.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadSuperviseurParcoursEffectif()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="formationsLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Formations:
              <span v-if="FormationsDeGroupe.length > 0">{{
                FormationsDeGroupe.length
              }}</span>
            </v-list-item-title>
             <v-list-item-title
              >Présences:
              <span
                v-if="PresencesFormationsDeGroupeDuSuperviseur.length > 0"
                >{{ PresencesFormationsDeGroupeDuSuperviseur.length }}</span
              >
            </v-list-item-title> 
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadFormationsDuSuperviseur()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="dotationsLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >Dotations:
              <span v-if="DotationsDeGroupe.length > 0">{{
                DotationsDeGroupe.length
              }}</span>
            </v-list-item-title>
            <v-list-item-title
              >Présences:
              <span v-if="PresencesDotationsDeGroupeDeSuperviseur.length > 0">{{
                PresencesDotationsDeGroupeDeSuperviseur.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadDotationsDuSuperviseur()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>

        <v-list-item>
          <v-list-item-avatar>
            <v-icon :class="formationsDeMasseLoaded ? 'success' : 'error'" dark
              >mdi-format-list-checks</v-icon
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              >F° de masse:
              <span v-if="FormationsDeMasse.length > 0">{{
                FormationsDeMasse.length
              }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="loadFormationsDeMasseDuSuperviseur()">
              <v-icon color="grey lighten-1">mdi-reload</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list> -->
      <div v-if="online">
        Recharger les données :
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              fab
              dark
              small
              color="green"
              @click="markUnLoaded()"
            >
              <v-icon dark>
                mdi-reload
              </v-icon>
            </v-btn>
          </template>
          <span>Recharger les données</span>
        </v-tooltip>
      </div>
    </v-card-text>

    <v-card-actions>
      <Navigation :elements="SuperviseurNavigation" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    //this.loadGenaralParams();
  },
  components: {
    Widget: require("@/components/Widget.vue").default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      start: this.$moment(Date.now())
        .subtract(3, "months")
        .format("YYYY-MM-DD HH:mm:ss"),
      end: this.$moment(Date.now())
        .add(3, "days")
        .format("YYYY-MM-DD HH:mm:ss"),
      headers: [{ text: "Actions", value: "actions", sortable: false }],
      loading: false,
    };
  },
  methods: {
    loadAll() {
      this.loading = true;
      this.loadParams();
      this.loadGroupes();
      this.loadMenages();
      this.GetMembresDuSuperviseur(this.user.uid);
      this.loadSuperviseurParcoursEffectif();
      this.loadFormationsDuSuperviseur();
      this.loadDotationsDuSuperviseur();
      this.loadFormationsDeMasseDuSuperviseur();
    },
    loadGenaralParams() {
      this.GetCampagneActive();
      this.getDistricts();
      this.GetRegions();
      this.GetProvinces();
      this.GetActivites();
      this.getBailleurs();
      this.getProjets();
      this.GetAllTypeDetailsEtape();
      this.GetAllRolesHorsGroupe();
      this.GetCampagnes();
      this.getEtapes();
      this.getDetailEtapes();
      this.GetThemes();
    },
    changeProjet(item) {
      this.$confirm(
        "Voulez vous vraiment changer de projet et vous déconnecter? Vous aurez besoin d'une connexion internet pour vous reconnecter"
      ).then((res) => {
        if (res) {
          console.log("changeProjet", item);
          var objet = { userId: this.user.uid, project: item };
          this.setProjectSelected(objet);
          this.userLogOut();
        }
      });
    },
    selectProjet(item) {
      console.log("selectProjet", item);
      var objet = { userId: this.user.uid, project: item };
      this.setProjectSelected(objet);
      this.$router.go(0);
    },

    continuer(item) {
      this.$router.push({ path: `/groupes/groupesFromProjet/` });
    },
    loadParams() {
      this.loadGenaralParams();
      var objet2 = { type: "paramsLoaded" };
      this.markLoaded(objet2);
    },
    loadGroupes() {
      var objet = { userId: this.user.uid, project: this.user.projetSelected };
      this.GetGroupesDeSuperviseur(objet);
      this.getMyHorsGroupe(this.user.uid);
      var objet2 = { type: "groupesLoaded" };
      this.markLoaded(objet2);
    },
    loadMenages() {
      var objet = { userId: this.user.uid, project: this.user.projetSelected };
      this.GetMenagesDuSuperviseur(objet);
      var objet2 = { type: "menagesLoaded" };
      this.markLoaded(objet2);
    },

    loadSuperviseurParcoursEffectif() {
      var objet = { userId: this.user.uid, project: this.user.projetSelected };
      this.GetEtapeEffectiveDeAnimateur(objet);
      //this.GetFichesOfAnimateur(objet);
      this.GetSuperviseurParcoursEffectif(objet);
      var objet2 = { type: "campagnesLoaded" };
      this.markLoaded(objet2);
    },

    loadFormationsDuSuperviseur() {
      var objet = {
        userId: this.user.uid,
        project: this.user.projetSelected,
        start: this.start,
        end: this.end,
      };
      this.GetFormationsDuSuperviseur(objet);
      //this.GetPresencesFormationsDeGroupeDuSuperviseur(objet);
      var objet2 = { type: "formationsLoaded" };
      this.markLoaded(objet2);
    },

    loadDotationsDuSuperviseur() {
      var objet = {
        userId: this.user.uid,
        project: this.user.projetSelected,
        start: this.start,
        end: this.end,
      };
      this.GetDotationsDuSuperviseur(objet);
     // this.GetSuperviseurPresencesDotationsDeGroupe(objet);
      var objet2 = { type: "dotationsLoaded" };
      this.markLoaded(objet2);
    },

    loadFormationsDeMasseDuSuperviseur() {
      var objet = {
        userId: this.user.uid,
        project: this.user.projetSelected,
        start: this.start,
        end: this.end,
      };
      this.GetFormationsDeMasseDeSuperviseur(objet);
      var objet2 = { type: "formationsDeMasseLoaded" };
      this.markLoaded(objet2);
    },

    ...mapActions({
      GetGroupesDeSuperviseur: "Groupes/GetGroupesDeSuperviseur",
      userLogOut: "Auth/userSignOut",
      setProjectSelected: "Projets/setProjectSelected",
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetAllTypeDetailsEtape: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      getMyGroupes: "Mygroupes/GetAll",
      getMyHorsGroupe: "HorsGroupe/GetAll",
      GetActivites: "Activites/GetAll",
      GetSuperviseurParcoursEffectif:
        "ParcoursEffectif/GetSuperviseurParcoursEffectif",
      GetFormationsDuSuperviseur:
        "FormationsDeGroupe/GetFormationsDuSuperviseur",
      GetFormationsDeMasseDeSuperviseur:
        "FormationsDeMasse/GetFormationsDeMasseDeSuperviseur",
      GetMembresDuSuperviseur: "Membres/GetMembresDuSuperviseur",
      GetMenagesDuSuperviseur: "Menages/GetMenagesDuSuperviseur",
      GetCommunesDuSuperviseurApartirDeDistricts:
        "Communes/GetCommunesDuSuperviseurApartirDeDistricts",
      GetFokontanyDuSuperviseurApartirDeDistricts:
        "Fokontany/GetFokontanyDuSuperviseurApartirDeDistricts",
      GetCampagnes: "Campagnes/GetAll",
      GetCampagneActive: "Campagnes/GetCampagneActive",
      GetPresencesFormationsDeGroupeDuSuperviseur:
        "PresencesFormationsDeGroupe/GetPresencesFormationsDeGroupeDuSuperviseur",
      GetDotationsDuSuperviseur: "DotationsDeGroupe/GetDotationsDuSuperviseur",
      GetSuperviseurPresencesDotationsDeGroupe:
        "PresencesDotationsDeGroupe/GetSuperviseurPresencesDotationsDeGroupe",
      getEtapes: "Etapes/GetAll",
      getDetailEtapes: "DetailEtapes/GetAll",
      getDistricts: "Districts/GetAll",
      GetRegions: "Regions/GetAll",
      GetProvinces: "Provinces/GetAll",
      GetThemes: "Themes/GetAll",
      GetEtapeEffectiveDeAnimateur:
        "EtapeEffective/GetEtapeEffectiveDeAnimateur",
      GetFichesOfAnimateur: "Fiches/get_fiche_of_animateur",
      markLoaded: "Utils/markLoaded",
      markUnLoaded: "Utils/markUnLoaded",
      setLocalStorageSize: "Utils/setLocalStorageSize",
      setOnlineState: "Online/setOnlineState",
    }),
  },
  computed: {
    ...mapState({
      paramsLoaded: (state) => state.Utils.paramsLoaded,
      groupesLoaded: (state) => state.Utils.groupesLoaded,
      membresLoaded: (state) => state.Utils.membresLoaded,
      menagesLoaded: (state) => state.Utils.menagesLoaded,
      campagnesLoaded: (state) => state.Utils.campagnesLoaded,
      formationsLoaded: (state) => state.Utils.formationsLoaded,
      dotationsLoaded: (state) => state.Utils.dotationsLoaded,
      formationsDeMasseLoaded: (state) => state.Utils.formationsDeMasseLoaded,
      online: (state) => state.Online.online,
      PresencesDotationsDeGroupeDeSuperviseur: (state) =>
        state.PresencesDotationsDeGroupe
          .PresencesDotationsDeGroupeDeSuperviseur,
      DotationsDeGroupe: (state) => state.DotationsDeGroupe.DotationsDeGroupe,
      horsGroupe: (state) => state.HorsGroupe.horsGroupe,
      etapeEffectiveDeAnimateur: (state) =>
        state.EtapeEffective.etapeEffectiveDeAnimateur,
      ficheDeAnimateur: (state) => state.Fiches.ficheDeAnimateur,
      PresencesFormationsDeGroupeDuSuperviseur: (state) =>
        state.PresencesFormationsDeGroupe
          .PresencesFormationsDeGroupeDuSuperviseur,
      MenagesDuSuperviseur: (state) => state.Menages.MenagesDuSuperviseur,
      groupesDeSuperviseur: (state) => state.Groupes.groupesDeSuperviseur,
      projetSelected: (state) => state.Projets.projetSelected,
      parametres: (state) => state.Parametres.parametres,
      user: (state) => state.Auth.user,
      projetSelected: (state) => state.Auth.projetSelected,
      campagneActive: (state) => state.Campagnes.campagneActive,
      ArrayOfCampagnesActives: (state) =>
        state.Campagnes.ArrayOfCampagnesActives,
      startDate: (state) => state.Campagnes.startDate,
      endDate: (state) => state.Campagnes.endDate,
      isAuthenticated: (state) => state.Auth.isAuthenticated,
      isAnimateur: (state) => state.Auth.isAnimateur,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      Mygroupes: (state) => state.Mygroupes.Mygroupes,
      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      FormationsDeMasse: (state) => state.FormationsDeMasse.FormationsDeMasse,
      MembresDuSuperviseur: (state) => state.Membres.MembresDuSuperviseur,
      listeDistrictsDuSuperviseur: (state) =>
        state.Utils.listeDistrictsDuSuperviseur,
      formationDeMassefilterdByProject(state) {
        var listeProjets = [];
        var userProjets = state.Auth.user.projets;
        _.forEach(userProjets, function (item, index) {
          listeProjets[index] = item.id_programme;
        });

        let output = _.filter(state.FormationsDeMasse.FormationsDeMasse, (v) =>
          _.includes(listeProjets, v.programmes_id_programme)
        );

        return output;
      },
    }),
    arrays() {
      var arr = [
        this.groupesLoaded,
        this.membresLoaded,
        this.menagesLoaded,
        this.campagnesLoaded,
        this.formationsLoaded,
        this.dotationsLoaded,
        this.formationsDeMasseLoaded,
        this.paramsLoaded,
      ];
      var ret = Object.values(arr).reduce((a, item) => a + item, 0);
      if (ret == 8) {
        this.setOnlineState(true);
        this.loading = false;
      }
      return ret;
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:last-child {
  border-bottom: none !important;
}
</style>
